import {Button} from "@zendeskgarden/react-buttons";
import {Body, Close, Footer, FooterItem, Header, Modal} from "@zendeskgarden/react-modals";
import {ReactElement} from "react";
import {Inline} from "@zendeskgarden/react-loaders";
import {COLORS} from "../../../constants/Colors";
import {AcquisitionProperty} from "../types";

export interface IPropertyDeleteConfirmation {
    properties: AcquisitionProperty[],
    selectedProperties: string[],
    loading: boolean,
    onClose: () => void,
    onConfirm: () => void,
}

export default function PropertyDeleteConfirmation(props: IPropertyDeleteConfirmation): ReactElement {
    function getSelectedPropertyName(propertyId: string | undefined): string {
        const property = props.properties.find(x => x.id === propertyId);

        if (!property?.name) {
            return "this property";
        }

        return property.name;
    }

    function getMessageText(): string {
        if (props.selectedProperties.length === 1) {
            return `Are you sure you want to deactivate ${getSelectedPropertyName(props.selectedProperties[0])}?`;
        } else {
            return `Are you sure you want to deactivate ${props.selectedProperties.length} properties?`;
        }
    }

    return (
        <Modal onClose={props.onClose}>
            <Header isDanger>
                Confirm Deactivate
            </Header>
            <Body>{getMessageText()}</Body>
            <Footer>
                <FooterItem>
                    <Button onClick={props.onClose} isBasic disabled={props.loading}>
                        Cancel
                    </Button>
                </FooterItem>
                <FooterItem>
                    <Button isPrimary isDanger onClick={props.onConfirm} disabled={props.loading}>
                        {
                            props.loading
                                ? <Inline size={24} color={COLORS.NEGATIVE_COLOR} aria-label="loading"/>
                                : <span>Deactivate</span>
                        }
                    </Button>
                </FooterItem>
            </Footer>
            <Close aria-label="Close modal" />
        </Modal>
    );
}